import React, { forwardRef } from 'react';
import MaterialTable from 'material-table';
import { CSSProperties } from '@material-ui/core/styles/withStyles';
import AddIcon from '@material-ui/icons/Add';
import { Paper } from '@material-ui/core';
import { useLanguageContext } from '../languages';
import { VideoAsset as VideoAssetType } from '../../utils/types';
import theme from '../../theme';

const VideoAssets: React.FC<VideoAssetsProps> = (props) => {
	const { videoAssets, onRowUpdate, onRowDelete, onRowAdd } = props;

	const { tableLocalization } = useLanguageContext();

	const rowStyle = (rowData: VideoAssetType): CSSProperties => {
		if (!rowData.url || !rowData.format) {
			return { color: theme.palette.error.main };
		} else {
			return {};
		}
	};

	return (
		<MaterialTable
			localization={tableLocalization}
			columns={[
				{
					title: 'ID',
					field: 'id',
					editable: 'never',
					lookup: {
						DASH: 'DASH',
						HLS: 'HLS',
						'HLS-Harvest': 'HLS-Harvest'
					}
				},
				{
					title: 'Format',
					field: 'format',
					lookup: {
						DASH: 'DASH',
						HLS: 'HLS'
					}
				},
				{
					title: 'Url',
					field: 'url'
				}
			]}
			editable={{ onRowUpdate, onRowDelete, onRowAdd }}
			data={videoAssets}
			options={{ pageSize: 2, search: false, sorting: false, rowStyle }}
			title={'Video Assets'}
			icons={{
				Add: forwardRef((props, ref) => <AddIcon {...props} ref={ref} data-testid='video-assets-actions-new' />)
			}}
			components={{
				Container: (props): JSX.Element => <Paper {...props} data-testid='video-assets-table' />
			}}
		/>
	);
};

type VideoAssetsProps = {
	videoAssets: VideoAssetType[] | [];
	onRowUpdate?: (newData: VideoAssetType, oldData?: VideoAssetType) => Promise<unknown>;
	onRowDelete?: (data: VideoAssetType) => Promise<unknown>;
	onRowAdd?: (data: VideoAssetType) => Promise<unknown>;
};

export default VideoAssets;
